import { ref } from 'vue';

// Estado reactivo para almacenar el número de clientes
const clientCount = ref<number>(0);

// Umbral a partir del cual se aplica caché
const CACHE_THRESHOLD = 10;

/**
 * Actualiza el contador de clientes
 * @param count Nuevo número de clientes
 */
function setClientCount(count: number): void {
  clientCount.value = count;
}

/**
 * Verifica si se debe aplicar caché basado en el número de clientes
 * @returns true si se debe aplicar caché, false en caso contrario
 */
function shouldApplyCache(): boolean {
  return clientCount.value >= CACHE_THRESHOLD;
}

/**
 * Limpia el contador de clientes
 */
function clearClientData(): void {
  clientCount.value = 0;
}

/**
 * Obtiene el número actual de clientes
 * @returns El número de clientes
 */
function getClientCount(): number {
  return clientCount.value;
}

export default {
  setClientCount,
  shouldApplyCache,
  getClientCount,
  CACHE_THRESHOLD,
  clearClientData,
};
